import { PureComponent } from 'react';

import config from '@/config';
import { money } from '@/core/money';

import Link from '../Link';
import StripeReceiptList from '../StripeReceiptList/StripeReceiptList';
import TransactionList from '../TransactionList';
import s from './BillingSettings.module.scss';

// Per-consultation credit-ledger charges (consumption). Credit accounts pay for these in
// credits, not dollars, so they must not surface as dollar charges on the billing page.
const CONSUMPTION_CHARGE_TYPES = new Set(['expert_time', 'booking_fee', 'transcription_fee']);

interface BillingProps {
  account: {
    isSMBAccount?: boolean;
    transactions: { money: any; charge_type?: string | null }[];
    stripeReceipts?: any[];
  };
}

class Billing extends PureComponent<BillingProps> {
  render(): JSX.Element {
    const { account } = this.props;
    const transactions = (account && account.transactions) || [];
    const stripeReceipts = (account && account.stripeReceipts) || [];

    // Credit (prepaid) accounts pay in credits, so per-consultation expert charges are not
    // dollar charges they owe. Show Stripe receipts as the history when they exist (those
    // reconcile to Stripe); otherwise show the credit ledger with consumption rows removed.
    // Strict `=== false` is deliberate: callers that don't fetch isSMBAccount fall through as
    // non-credit (unchanged behavior) rather than being misclassified as credit.
    const isCreditAccount = account?.isSMBAccount === false;
    const showReceiptsAsHistory = isCreditAccount && stripeReceipts.length > 0;

    const ledgerTransactions = transactions.filter(
      (t) =>
        money(t.money).cents !== 0 &&
        !(isCreditAccount && CONSUMPTION_CHARGE_TYPES.has(t.charge_type ?? ''))
    );

    return (
      <div>
        {showReceiptsAsHistory ? (
          <div>
            <StripeReceiptList receipts={stripeReceipts} />
          </div>
        ) : (
          <>
            <div>
              <TransactionList
                transactions={ledgerTransactions}
                amountColumn={{
                  header: 'Amount',
                  field: 'money',
                }}
              />
            </div>
            {!isCreditAccount && stripeReceipts.length > 0 && (
              <div>
                <StripeReceiptList receipts={stripeReceipts} />
              </div>
            )}
          </>
        )}
        <div className={s.questions}>
          Questions about billing? Contact our{' '}
          <Link href={`${config.helpCenterUrl}/help-center`}>customer care team</Link>.
        </div>
      </div>
    );
  }
}

export default Billing;
